var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 62 48",
    height: 48,
    viewBox: "0 0 62 48",
    width: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8b8783"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.009 15.579c-5.106 0-9.259 4.153-9.259 9.259 0 5.105 4.153 9.259 9.259 9.259s9.26-4.154 9.26-9.259c.001-5.106-4.154-9.259-9.26-9.259z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.004 5.819h-10.606l-3.002-3.191s-2.002-2.711-4.713-2.586h-4.506-4.337-4.505c-2.711-.125-4.713 2.586-4.713 2.586l-3.002 3.191h-10.605c-3.316 0-6.006 2.689-6.006 6.006v30.03c0 3.316 2.689 6.006 6.006 6.006h49.989c3.316 0 6.006-2.689 6.006-6.006v-30.03c0-3.317-2.69-6.006-6.006-6.006zm-24.995 33.285c-7.865 0-14.264-6.4-14.264-14.265s6.399-14.265 14.264-14.265c7.866 0 14.264 6.399 14.264 14.265 0 7.864-6.398 14.265-14.264 14.265z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cf1cad4c760a277dda0b59b4614a7425.svg";
export { ForwardRef as ReactComponent };